module.exports = __webpack_public_path__ + "img/undraw_accept_request_vdsd.f7785e80.svg";